import { render, staticRenderFns } from "./contentBox.vue?vue&type=template&id=312da11b&scoped=true&"
import script from "./contentBox.vue?vue&type=script&lang=js&"
export * from "./contentBox.vue?vue&type=script&lang=js&"
import style0 from "./contentBox.vue?vue&type=style&index=0&id=312da11b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312da11b",
  null
  
)

export default component.exports